import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import {
    Observable,
    Subject,
    catchError,
    debounceTime,
    distinctUntilChanged,
    finalize,
    map,
    of,
    switchMap,
    takeUntil,
    tap,
} from 'rxjs';
import { Generic, GenericCompartimentSearch } from 'src/app/interfaces/generic.interface';
import {
    SearchDocumentsPayload,
    Destinatie,
    Info,
    Origin,
    SearchedDocument,
    StoreBorderou
} from '../borderou.interface';
import { BorderouService } from '../borderou.service';
import { CommonService } from 'src/app/services/common.service';
import { DashboardService } from 'src/app/components/dashboard-documente/dashboard.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { NotificationService } from 'src/app/services/notification.service';
import { UserOrganigramaSearchPayload } from 'src/app/interfaces/common.interface';
import { formatDate } from '@angular/common';
import { OperatorAccess } from 'src/app/platform/nomenclatoare/operatori/operatori.interface';

interface DestinatariTableRow {
    destination_directie_id: number;
    destination_directie_name: string;
    destination_compartiment_id: number;
    destination_compartiment_name: string;
    total: number;
}

@Component({
    selector: 'app-add-borderou',
    templateUrl: './add-borderou.component.html',
    styleUrls: ['./add-borderou.component.scss'],
})
export class AddBorderouComponent implements OnInit {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;
    helper = helper;

    isLoading: boolean = false;
    today = new Date();
    activeAccess: OperatorAccess | null = null;

    showSelectedDocs: boolean = false;

    showOperatoriList: boolean = false;
    operatoriList: { id: number; name: string; added: boolean; }[] = []
    allOperatoriAdded: boolean = false;

    selectedDocuments: SearchedDocument[] = [];
    selectedDocumentsNr: number = 0;
    borderouDocuments: SearchedDocument[] = [];
    destinatariTableData: DestinatariTableRow[] = [];

    storeMultiple: boolean = false;

    defaultParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    form: FormGroup = new FormGroup({
        origin_directie_id: new FormControl(null),
        origin_directie_name: new FormControl(''),
        origin_compartiment_id: new FormControl(null),
        origin_compartiment_name: new FormControl(''),
        origin_user_id: new FormControl(-1),
        origin_user_name: new FormControl(''),
        destinatie_directie_id: new FormControl(null),
        destinatie_directie_name: new FormControl(''),
        destinatie_compartiment_id: new FormControl(null),
        destinatie_compartiment_name: new FormControl(''),
        destinatie_user_id: new FormControl(-1),
        destinatie_user_name: new FormControl(''),
        document_number: new FormControl(null),
        date_input_start: new FormControl(''),
        date_input_end: new FormControl(''),
    });

    private destroy$ = new Subject<void>();

    directiiOrigin: Generic[] = [];
    filteredDirectiiOrigin: Generic[] = [];
    directiiOriginControl = new FormControl();

    compartimenteOrigin: GenericCompartimentSearch[] = [];
    compartimenteOriginControl = new FormControl();
    isCompartimenteOriginLoading = false;
    showCompartimenteOriginMessage = true;
    compartimenteOriginLoadComplete = false;

    operatoriOrigin: Generic[] = [];
    filteredOperatoriOrigin: Generic[] = [];
    operatoriOriginControl = new FormControl();

    directiiDestinatie: Generic[] = [];
    filteredDirectiiDestinatie: Generic[] = [];
    directiiDestinatieControl = new FormControl();

    compartimenteDestinatie: GenericCompartimentSearch[] = [];
    compartimenteDestinatieControl = new FormControl();
    isCompartimenteDestinatieLoading = false;
    showCompartimenteDestinatieMessage = true;
    compartimenteDestinatieLoadComplete = false;

    operatoriDestinatie: Generic[] = [];
    filteredOperatoriDestinatie: Generic[] = [];
    operatoriDestinatieControl = new FormControl();

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            activeAccess: OperatorAccess,
        },
        private dialogRef: MatDialogRef<AddBorderouComponent>,
        private borderouService: BorderouService,
        private commonService: CommonService,
        private dashboardService: DashboardService,
        public permissionsService: PermissionsService,
        public notificationService: NotificationService,
    ) {
        this.activeAccess = data.activeAccess;
    }

    ngOnInit() {
        this.loadDirectiiActive();

        if (this.activeAccess) {
            // Set default directie, compartiment, user from activeAccess
            this.directiiOriginControl.setValue({
                id: this.activeAccess.id_directie,
                name: this.activeAccess.denumire_directie,
            });
            this.form.controls['origin_directie_id'].patchValue(this.activeAccess.id_directie);
            this.form.controls['origin_directie_name'].patchValue(this.activeAccess.denumire_directie);

            this.compartimenteOriginControl.setValue({
                id: this.activeAccess.id_compartiment,
                name: this.activeAccess.denumire_compartiment,
            });
            this.form.controls['origin_compartiment_id'].patchValue(this.activeAccess.id_compartiment);
            this.form.controls['origin_compartiment_name'].patchValue(this.activeAccess.denumire_compartiment);

            this.loadOperatoriOrigin();
            this.form.controls['origin_user_id'].patchValue(this.activeAccess.id_user);
            this.form.controls['origin_user_name'].patchValue(this.activeAccess.name_user);
        }

        this.compartimenteOriginControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(compartiment => {
            if (typeof compartiment === 'string') {
                this.fetchCompartimenteOrigin(compartiment);
                this.showCompartimenteOriginMessage = true;
                this.compartimenteOriginLoadComplete = false;
            }
        });

        this.compartimenteDestinatieControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(compartiment => {
            if (typeof compartiment === 'string') {
                this.fetchCompartimenteDestinatie(compartiment);
                this.showCompartimenteDestinatieMessage = true;
                this.compartimenteDestinatieLoadComplete = false;
            }
        });

        this.renderFieldsSearch();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    renderFieldsSearch() {
        this.directiiOriginControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.directiiOrigin);
                }
                if (inputValue.length < 1) {
                    this.filteredDirectiiOrigin = this.directiiOrigin;
                    return of(this.directiiOrigin);
                }
                return this.filterDirectiiOrigin(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredDirectiiOrigin = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.operatoriOriginControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.operatoriOrigin);
                }
                if (inputValue.length < 1) {
                    this.filteredOperatoriOrigin = this.operatoriOrigin;
                    return of(this.operatoriOrigin);
                }
                return this.filterOperatoriOrigin(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredOperatoriOrigin = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.directiiDestinatieControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.directiiDestinatie);
                }
                if (inputValue.length < 1) {
                    this.filteredDirectiiDestinatie = this.directiiDestinatie;
                    return of(this.directiiDestinatie);
                }
                return this.filterDirectiiDestinatie(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredDirectiiDestinatie = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.operatoriDestinatieControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.operatoriDestinatie);
                }
                if (inputValue.length < 1) {
                    this.filteredOperatoriDestinatie = this.operatoriDestinatie;
                    return of(this.operatoriDestinatie);
                }
                return this.filterOperatoriDestinatie(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredOperatoriDestinatie = data;
            }),
            catchError(() => of([]))
        ).subscribe();
    }

    loadDirectiiActive() {
        this.isLoading = true;
        this.commonService
            .getDirectiiActive()
            .pipe(
                map((results: any) => [...results]),
                finalize(() => this.isLoading = false)
            )
            .subscribe({
                next: (results) => {
                    this.directiiOrigin = results;
                    this.directiiDestinatie = results;

                    this.filteredDirectiiOrigin = [...this.directiiOrigin];
                    this.filteredDirectiiDestinatie = [...this.directiiDestinatie];
                },
                error: (error) => {
                    console.error('Error loading directii', error);
                    this.filteredDirectiiOrigin = [];
                    this.filteredDirectiiDestinatie = [];
                },
            });
    }

    onDirectiiOriginChange(selectedCompartiment: Generic): void {
        this.form.controls['origin_directie_id'].patchValue(selectedCompartiment.id);
        this.form.controls['origin_directie_name'].patchValue(selectedCompartiment.name);

        this.compartimenteOriginControl.patchValue('');
        this.form.controls['origin_compartiment_id'].patchValue(null);
        this.form.controls['origin_compartiment_name'].patchValue('');

        this.operatoriOrigin = [];
        this.filteredOperatoriOrigin = [];
        this.operatoriOriginControl.patchValue('');
        this.form.controls['origin_user_id'].patchValue(-1);
        this.form.controls['origin_user_name'].patchValue('');
        this.resetOperatoriList();
    }

    displayDirectiiOrigin(selectedDirectie: Generic): string {
        return selectedDirectie && selectedDirectie.name ? selectedDirectie.name : '';
    }

    onDirectiiOriginBlur() {
        const currentValue = this.directiiOriginControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.directiiOriginControl.patchValue('');
            this.form.controls['origin_directie_id'].patchValue(null);
            this.form.controls['origin_directie_name'].patchValue('');

            this.compartimenteOriginControl.patchValue('');
            this.form.controls['origin_compartiment_id'].patchValue(null);
            this.form.controls['origin_compartiment_name'].patchValue('');

            this.operatoriOrigin = [];
            this.filteredOperatoriOrigin = [];
            this.operatoriOriginControl.patchValue('');
            this.form.controls['origin_user_id'].patchValue(-1);
            this.form.controls['origin_user_name'].patchValue('');
            this.resetOperatoriList();
        }
    }

    fetchCompartimenteOrigin(compartiment: string) {
        // const directieValue = this.form.get('origin_directie_id')?.value;
        // const directie = directieValue && directieValue !== -1 ? directieValue : undefined;
        if (compartiment.length >= 2) {
            this.isCompartimenteOriginLoading = true;
            this.commonService.searchCompartimenteActive(undefined, compartiment).subscribe({
                next: (response: any) => {
                    this.compartimenteOrigin = response;
                    this.isCompartimenteOriginLoading = false;
                    this.compartimenteOriginLoadComplete = true;
                    this.showCompartimenteOriginMessage = this.compartimenteOrigin.length === 0;
                },
                error: (err: any) => {
                    this.isCompartimenteOriginLoading = false;
                    this.showCompartimenteOriginMessage = true;
                    this.compartimenteOriginLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.compartimenteOrigin = [];
            this.showCompartimenteOriginMessage = true;
            this.compartimenteOriginLoadComplete = false;
        }
    }

    onCompartimenteOriginSelected(selectedCompartiment: GenericCompartimentSearch): void {
        this.form.controls['origin_compartiment_id'].patchValue(selectedCompartiment.id);
        this.form.controls['origin_compartiment_name'].patchValue(selectedCompartiment.name);

        this.directiiOriginControl.setValue({
            id: selectedCompartiment.directie_id,
            name: selectedCompartiment.directie_name,
        });
        this.form.controls['origin_directie_id'].patchValue(selectedCompartiment.directie_id);
        this.form.controls['origin_directie_name'].patchValue(selectedCompartiment.directie_name);

        this.loadOperatoriOrigin();
        this.operatoriOriginControl.patchValue('');
        this.form.controls['origin_user_id'].patchValue(-1);
        this.form.controls['origin_user_name'].patchValue('');
        this.resetOperatoriList();
    }

    displayCompartimenteOrigin(selectedCompartiment: GenericCompartimentSearch): string {
        return selectedCompartiment && selectedCompartiment.name ? selectedCompartiment.name : '';
    }

    onCompartimenteOriginBlur() {
        const currentValue = this.compartimenteOriginControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.compartimenteOriginControl.patchValue('');
            this.form.controls['origin_compartiment_id'].patchValue(null);
            this.form.controls['origin_compartiment_name'].patchValue('');

            this.operatoriOrigin = [];
            this.filteredOperatoriOrigin = [];
            this.operatoriOriginControl.patchValue('');
            this.form.controls['origin_user_id'].patchValue(-1);
            this.form.controls['origin_user_name'].patchValue('');
            this.resetOperatoriList();
        }
    }

    loadOperatoriOrigin() {
        this.isLoading = true;
        const payload: UserOrganigramaSearchPayload = {
            directie_id: this.form.controls['origin_directie_id'].value,
            compartiment_id: this.form.controls['origin_compartiment_id'].value,
            view_all: 1,
        }
        this.commonService
            .getUsersByOrganigrama(payload)
            .pipe(
                map((results: any) => [...results]),
                finalize(() => { this.isLoading = false })
            ).subscribe({
                next: (data) => {
                    this.operatoriOrigin = [...data];
                    this.filteredOperatoriOrigin = [...this.operatoriOrigin];

                    this.operatoriList = this.operatoriOrigin.map(operator => {
                        return {
                            id: operator.id,
                            name: operator.name,
                            added: false,
                        }
                    });
                    // If the active user is found in operatoriList, set the added property to true and update the form
                    const foundActiveUser = this.operatoriList.find(user => user.id === this.activeAccess?.id_user)
                    if (foundActiveUser) {
                        foundActiveUser.added = true;
                        this.form.controls['origin_user_id'].patchValue(this.activeAccess?.id_user);
                        this.form.controls['origin_user_name'].patchValue(this.activeAccess?.name_user);
                    }
                    // If the active user is the only user in operatoriList, set allOperatoriAdded to true
                    if (this.operatoriList.length === 1 && foundActiveUser) {
                        this.allOperatoriAdded = true;
                    } else {
                        this.allOperatoriAdded = false;
                    }
                },
                error: (error) => {
                    console.error(error);
                    this.operatoriOrigin = [];
                    this.filteredOperatoriOrigin = [];

                    this.resetOperatoriList();
                },
            });
    }

    onOperatoriOriginChange(operatorId: number): void {
        const selectedOperator = this.operatoriOrigin.find(operator => operator.id === operatorId);

        if (selectedOperator) {
            // this.form.controls['origin_user_id'].patchValue(selectedOperator.id);
            this.form.controls['origin_user_name'].patchValue(selectedOperator.name);
        }
    }

    onDirectiiDestinatieChange(selectedCompartiment: Generic): void {
        this.form.controls['destinatie_directie_id'].patchValue(selectedCompartiment.id);
        this.form.controls['destinatie_directie_name'].patchValue(selectedCompartiment.name);

        this.compartimenteDestinatieControl.patchValue('');
        this.form.controls['destinatie_compartiment_id'].patchValue(null);
        this.form.controls['destinatie_compartiment_name'].patchValue('');

        this.operatoriDestinatie = [];
        this.filteredOperatoriDestinatie = [];
        this.operatoriDestinatieControl.patchValue('');
        this.form.controls['destinatie_user_id'].patchValue(-1);
        this.form.controls['destinatie_user_name'].patchValue('');
    }

    displayDirectiiDestinatie(selectedDirectie: Generic): string {
        return selectedDirectie && selectedDirectie.name ? selectedDirectie.name : '';
    }

    onDirectiiDestinatieBlur() {
        const currentValue = this.directiiDestinatieControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.directiiDestinatieControl.patchValue('');
            this.form.controls['destinatie_directie_id'].patchValue(null);
            this.form.controls['destinatie_directie_name'].patchValue('');

            this.compartimenteDestinatieControl.patchValue('');
            this.form.controls['destinatie_compartiment_id'].patchValue(null);
            this.form.controls['destinatie_compartiment_name'].patchValue('');

            this.operatoriDestinatie = [];
            this.filteredOperatoriDestinatie = [];
            this.operatoriDestinatieControl.patchValue('');
            this.form.controls['destinatie_user_id'].patchValue(-1);
            this.form.controls['destinatie_user_name'].patchValue('');
        }
    }

    fetchCompartimenteDestinatie(compartiment: string) {
        // const directieValue = this.form.get('destinatie_directie_id')?.value;
        // const directie = directieValue && directieValue !== -1 ? directieValue : undefined;
        if (compartiment.length >= 2) {
            this.isCompartimenteDestinatieLoading = true;
            this.commonService.searchCompartimenteActive(undefined, compartiment).subscribe({
                next: (response: any) => {
                    this.compartimenteDestinatie = response;
                    this.isCompartimenteDestinatieLoading = false;
                    this.compartimenteDestinatieLoadComplete = true;
                    this.showCompartimenteDestinatieMessage = this.compartimenteDestinatie.length === 0;
                },
                error: (err: any) => {
                    this.isCompartimenteDestinatieLoading = false;
                    this.showCompartimenteDestinatieMessage = true;
                    this.compartimenteDestinatieLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.compartimenteDestinatie = [];
            this.showCompartimenteDestinatieMessage = true;
            this.compartimenteDestinatieLoadComplete = false;
        }
    }

    onCompartimenteDestinatieSelected(selectedCompartiment: GenericCompartimentSearch): void {
        this.form.controls['destinatie_compartiment_id'].patchValue(selectedCompartiment.id);
        this.form.controls['destinatie_compartiment_name'].patchValue(selectedCompartiment.name);

        this.directiiDestinatieControl.setValue({
            id: selectedCompartiment.directie_id,
            name: selectedCompartiment.directie_name,
        });
        this.form.controls['destinatie_directie_id'].patchValue(selectedCompartiment.directie_id);
        this.form.controls['destinatie_directie_name'].patchValue(selectedCompartiment.directie_name);

        this.loadOperatoriDestinatie();
        this.operatoriDestinatieControl.patchValue('');
        this.form.controls['destinatie_user_id'].patchValue(-1);
        this.form.controls['destinatie_user_name'].patchValue('');
    }

    displayCompartimenteDestinatie(selectedCompartiment: GenericCompartimentSearch): string {
        return selectedCompartiment && selectedCompartiment.name ? selectedCompartiment.name : '';
    }

    onCompartimenteDestinatieBlur() {
        const currentValue = this.compartimenteDestinatieControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.compartimenteDestinatieControl.patchValue('');
            this.form.controls['destinatie_compartiment_id'].patchValue(null);
            this.form.controls['destinatie_compartiment_name'].patchValue('');

            this.operatoriDestinatie = [];
            this.filteredOperatoriDestinatie = [];
            this.operatoriDestinatieControl.patchValue('');
            this.form.controls['destinatie_user_id'].patchValue(-1);
            this.form.controls['destinatie_user_name'].patchValue('');
        }
    }

    loadOperatoriDestinatie() {
        this.isLoading = true;
        const payload: UserOrganigramaSearchPayload = {
            directie_id: this.form.controls['destinatie_directie_id'].value,
            compartiment_id: this.form.controls['destinatie_compartiment_id'].value,
            view_all: 1,
        }
        this.commonService
            .getUsersByOrganigrama(payload)
            .pipe(
                map((results: any) => [...results]),
                finalize(() => { this.isLoading = false })
            ).subscribe({
                next: (data) => {
                    this.operatoriDestinatie = [...data];
                    this.filteredOperatoriDestinatie = [...this.operatoriDestinatie];
                },
                error: (error) => {
                    console.error(error);
                    this.operatoriDestinatie = [];
                    this.filteredOperatoriDestinatie = [];
                },
            });
    }

    onOperatoriDestinatieChange(operatorId: number): void {
        const selectedOperator = this.operatoriDestinatie.find(operator => operator.id === operatorId);

        if (selectedOperator) {
            // this.form.controls['destinatie_user_id'].patchValue(selectedOperator.id);
            this.form.controls['destinatie_user_name'].patchValue(selectedOperator.name);
        }
    }

    normalizeString(value: string): string {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }

    filterDirectiiOrigin(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.directiiOrigin.filter(directie =>
            this.normalizeString(directie.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterOperatoriOrigin(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.operatoriOrigin.filter(operator =>
            this.normalizeString(operator.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterDirectiiDestinatie(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.directiiDestinatie.filter(directie =>
            this.normalizeString(directie.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterOperatoriDestinatie(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.operatoriDestinatie.filter(operator =>
            this.normalizeString(operator.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    toggleOperatoriList() {
        this.showOperatoriList = !this.showOperatoriList;
    }

    updateAllOperatoriAdded() {
        this.allOperatoriAdded = this.operatoriList.every(operator => operator.added);
    }

    addAllOperatori(added: boolean) {
        this.allOperatoriAdded = added;

        this.operatoriList.forEach(operator => (operator.added = added));
    }

    resetOperatoriList() {
        this.operatoriList.length = 0;
        this.allOperatoriAdded = false;
    }

    generatePayload() {
        const date_input_start = this.form.value.date_input_start;
        const date_input_end = this.form.value.date_input_end;
        const userIDs = this.operatoriList.filter(operator => operator.added === true).map(operator => operator.id);

        const origin: Origin = {
            directie_id: this.form.get('origin_directie_id')?.value,
            directie_name: this.form.get('origin_directie_name')?.value,
            compartiment_id: this.form.get('origin_compartiment_id')?.value,
            compartiment_name: this.form.get('origin_compartiment_name')?.value,
            user_id: this.form.get('origin_user_id')?.value,
            user_name: this.form.get('origin_user_name')?.value,
            operator_type: this.showOperatoriList,
            user_ids: userIDs,
        };

        const destinatie: Destinatie = {
            directie_id: this.form.get('destinatie_directie_id')?.value,
            directie_name: this.form.get('destinatie_directie_name')?.value,
            compartiment_id: this.form.get('destinatie_compartiment_id')?.value,
            compartiment_name: this.form.get('destinatie_compartiment_name')?.value,
            user_id: this.form.get('destinatie_user_id')?.value,
            user_name: this.form.get('destinatie_user_name')?.value,
        };

        const info: Info = {
            number: this.form.get('document_number')?.value,
            date_input_start: this.form.get('date_input_start')?.value,
            date_start: date_input_start ? formatDate(date_input_start, 'yyyy-MM-dd', 'en-US') : '',
            date_input_end: this.form.get('date_input_end')?.value,
            date_end: date_input_end ? formatDate(date_input_end, 'yyyy-MM-dd', 'en-US') : '',
        };

        const payload: SearchDocumentsPayload = { origin: origin, destinatie: destinatie, info: info };

        return payload;
    }

    searchDocuments() {
        this.isLoading = true;

        const payload: SearchDocumentsPayload = this.generatePayload();

        this.dashboardService
            .searchDocuments(payload)
            .pipe(
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.selectedDocuments = results.map(document => {
                        return { ...document, selected: false }
                    });
                    this.selectedDocumentsNr = 0;

                    this.storeMultiple = false;
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    changeView() {
        this.showSelectedDocs = !this.showSelectedDocs;
    }

    refresh() {
        this.searchDocuments();
    }

    selectDocument(index: number) {
        this.selectedDocuments[index].selected = !this.selectedDocuments[index].selected;

        if (this.selectedDocuments[index].selected) {
            this.selectedDocumentsNr++;
        } else {
            this.selectedDocumentsNr--;
        }
    }

    selectAllDocuments() {
        if (this.selectedDocumentsNr !== this.selectedDocuments.length) {
            this.selectedDocuments.forEach(doc => (doc.selected = true));
            this.selectedDocumentsNr = this.selectedDocuments.length;
        } else {
            this.selectedDocuments.forEach(doc => (doc.selected = false));
            this.selectedDocumentsNr = 0;
        }
    }

    addDocumentsToBorderou() {
        this.selectedDocuments.forEach(doc => {
            // Check if a selected doc doesn't already exist in borderouDocuments and add it
            if (doc.selected && !this.borderouDocuments.some(borderouDoc => borderouDoc.id === doc.id)) {
                const newDoc: SearchedDocument = { ...doc };
                this.borderouDocuments.push(newDoc);
            }
        });

        this.generateDestinatariTableData();

        this.showSelectedDocs = true;
    }

    addAllDocumentsToBorderou() {
        this.isLoading = true;

        const payload: SearchDocumentsPayload = this.generatePayload();

        this.dashboardService
            .searchAllDocuments(payload)
            .pipe(
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.selectedDocuments = results.documents.map(document => {
                        return { ...document, selected: false }
                    });
                    this.selectedDocumentsNr = 0;

                    this.storeMultiple = true;

                    // Select all documents directly
                    this.selectAllDocuments();
                    this.addDocumentsToBorderou();
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    generateDestinatariTableData() {
        const destinatariMap: Map<string, DestinatariTableRow> = new Map();
        this.borderouDocuments.forEach(borderouDoc => {
            const directieIdS = borderouDoc.destination_directie_id ? borderouDoc.destination_directie_id.toString() : '0';
            const compartimnetIdS = borderouDoc.destination_compartiment_id ? borderouDoc.destination_compartiment_id.toString() : '0';
            const identifier = directieIdS + compartimnetIdS;
            if (!destinatariMap.has(identifier)) {
                destinatariMap.set(identifier, {
                    destination_directie_id: borderouDoc.destination_directie_id,
                    destination_directie_name: borderouDoc.destination_directie_name,
                    destination_compartiment_id: borderouDoc.destination_compartiment_id,
                    destination_compartiment_name: borderouDoc.destination_compartiment_name,
                    total: 1
                })
            } else {
                destinatariMap.get(identifier)!.total++;
            }
        })

        this.destinatariTableData = Array.from(destinatariMap.values());
    }

    refreshBorderouDocs() {
        this.borderouDocuments.length = 0;

        this.generateDestinatariTableData();
    }

    deleteBorderouDoc(index: number) {
        this.borderouDocuments.splice(index, 1);

        this.generateDestinatariTableData();
    }

    storeBorderou() {
        if (!this.borderouDocuments.length) return;

        this.isLoading = true;

        const payloadInfo: SearchDocumentsPayload = this.generatePayload();

        const payload: StoreBorderou = {
            document_ids: this.borderouDocuments.map(borderouDoc => borderouDoc.id),
            info: payloadInfo,
        }

        const route = this.storeMultiple ? this.borderouService.storeMultiple(payload) : this.borderouService.store(payload);

        route
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
